import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { HomeComponent } from './home/home.component';
import { TealiumScriptService } from 'src/app/tealium-script/tealium-script.service';
import { constants } from 'src/app/configs/config-internal-constants';
import { LaunchDarklyService } from 'src/app/common/services/launchdarkly.service';
import { LDEvaluationDetail } from 'launchdarkly-js-client-sdk';

@Component({
    selector: 'olb-app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [HomeComponent]
})
export class AppComponent implements OnInit {
  constructor(
    private titleService: Title,
    private readonly tealiumService: TealiumScriptService,
    private readonly launchDarklyService: LaunchDarklyService
  ) {}

  ngOnInit(): void {
    this.titleService.setTitle('Contact Us');
    this.initializeTealiumScript();
  }

  initializeTealiumScript(): void {
    const tealiumfeatureFlag = constants.thirdpartyAdobeEnabled;
    this.launchDarklyService.getFeatureFlagDetail([tealiumfeatureFlag]).subscribe({
      next: (flagData: Map<string, LDEvaluationDetail>) => {
          if (flagData.get(tealiumfeatureFlag) && flagData.get(tealiumfeatureFlag).value === true) {
            this.tealiumService.initialize().catch((error) => {
              // Incase of error, do nothing
            });
          }
        },
        error: (error) => {
          //No need to handle error
        }
    });
  }

}
